import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    AgentPromptCollectionGetParams,
    AgentPromptFolderableCollectionViewGetResponse,
} from 'AgentApp/ts/features/agent-prompt-list/interfaces/agent-prompt-view-responses.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({ providedIn: 'root' })
export class AgentPromptListService {
    private readonly ajaxService = inject(AjaxService);

    private readonly urlsService = inject(UrlsService);

    getAgentPrompts(
        getParams: AgentPromptCollectionGetParams
    ): Observable<AgentPromptFolderableCollectionViewGetResponse> {
        const url = this.urlsService.AGENT.PROMPT_LIST_COLLECTION;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.ajaxService.getDataObserveBody<AgentPromptFolderableCollectionViewGetResponse>(url, {
            ...getParams,
            tz,
        });
    }

    getAgentPrompt(agentPromptId: number): Observable<{ prompt: { id: number; name: string; prompt: string } }> {
        const url = this.urlsService.getUrl(this.urlsService.AGENT.PROMPT_DETAIL, { agentPromptId });
        return this.ajaxService.getDataObserveBody<{ prompt: { id: number; name: string; prompt: string } }>(url);
    }

    createAgentPrompt(body: { name?: string; prompt: string }): Observable<void> {
        return this.ajaxService.postJsonDataObserveBody<void>(this.urlsService.AGENT.PROMPT_LIST_COLLECTION, body);
    }

    updateAgentPrompt(agentPromptId: number, body: { name: string; prompt: string }): Observable<void> {
        const url = this.urlsService.getUrl(this.urlsService.AGENT.PROMPT_DETAIL, { agentPromptId });
        return this.ajaxService.putJsonDataObserveBody<void>(url, body);
    }

    duplicateAgentPrompt(agentPromptId: number): Observable<void> {
        const url = this.urlsService.getUrl(this.urlsService.AGENT.PROMPT_DUPLICATE, { agentPromptId });
        return this.ajaxService.postJsonDataObserveBody<void>(url, {});
    }
}
